// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"409":"059ff347","485":"c1815c69","611":"caa58c50","787":"3fc29379","820":"1cd681c6","848":"8dd83ce6","907":"84f631f6","928":"9981b1e8"}[chunkId] + ".chunk.js";
};